import type { ReservationReportRow } from '../../api/types/reports';

/** "DD.MM.YYYY HH:mm:ss" (Report/Reservations'ın `expireAt` formatı) → epoch ms, ya da
 *  parse edilemezse/boşsa null. */
export function parseLegacyDateTime(value: string | null | undefined): number | null {
  if (!value) return null;
  const match = value.match(/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2}):(\d{2})$/);
  if (!match) return null;
  const [, day, month, year, hour, minute, second] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second));
  return Number.isNaN(date.getTime()) ? null : date.getTime();
}

/** "Ödemeye devam edilebilir" — sepeti hâlâ var, ödeme/biletleme henüz tamamlanmamış,
 *  ve son geçerlilik tarihi geçmemiş rezervasyonlar. */
const RESUMABLE_STATUSES = new Set(['Prebooked', 'StagedBooking']);

export function isPaymentResumable(row: ReservationReportRow): boolean {
  if (!row.shoppingCartId) return false;
  if (!row.statu || !RESUMABLE_STATUSES.has(row.statu)) return false;
  const deadline = parseLegacyDateTime(row.expireAt);
  return deadline !== null && deadline > Date.now();
}

/** `AirFlowPage` bu query parametrelerini okuyup ilgili sepeti getirir ve doğrudan
 *  ödeme adımına atlar (bkz. AirFlowPage.tsx'teki `resume`/`expireAt` kullanımı). */
export function resumePaymentUrl(row: ReservationReportRow): string {
  const params = new URLSearchParams({ resume: row.shoppingCartId ?? '' });
  if (row.expireAt) params.set('expireAt', row.expireAt);
  return `/air?${params.toString()}`;
}
